import { useEffect, useState } from 'react';
import { Box, Typography, TextField, Button, Card } from '@mui/material';
import {
  getOtherFeeTypesConfigurations,
  postOtherFeeTypesConfigurations,
} from '../../../features/payments/PaymentSlice';
import { useDispatch } from 'react-redux';
import Spinner from '../../../components/UIElements/Spinner';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import useNotification from '../../../hooks/useNotification';
import ToastNotification from '../../../components/UIElements/ToastNotification';
import PersonIcon from '@mui/icons-material/Person';
export default function TotalFeesList({ StudentId }) {
  const [feesConfigurations, setFeesConfigurations] = useState('');
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();
  const [hasError, setHasError] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const { notification, showSuccess, showError, hideNotification } =
    useNotification();
  const status = localStorage.getItem('StudentStatus');
  const handleAmountChange = (index, value) => {
    const duplicateOne = [...feesConfigurations];
    const currentOne = duplicateOne[index];
    var currentamount = currentOne.amount;
    var newdue = 0;
    //big value
    if (currentamount - value < 0) {
      newdue = currentOne.due + Number(value - currentamount);
      setHasError(false);
    } else if (currentamount - value > 0) {
      //smaller value
      newdue = currentOne.due - Number(currentamount - value);
      if (newdue < 0) {
        setHasError(true);
      } else {
        setHasError(false);
      }
    } else {
      newdue = currentOne.due;
      setHasError(false);
    }
    const updatedOne = {
      ...currentOne,
      amount: value,
      due: newdue,
    };
    duplicateOne[index] = updatedOne;
    const total = duplicateOne?.reduce((sum, f) => sum + Number(f.amount), 0);
    setTotalAmount(total);
    setFeesConfigurations(duplicateOne);
  };

  const handleSubmit = async (e) => {
    const list = feesConfigurations.map((item) =>
      item.amount ? item : { ...item, amount: 0 },
    );
    e.preventDefault();
    try {
      setIsSubmitting(true);
      const response = await dispatch(
        postOtherFeeTypesConfigurations({
          data: list,
          StudentId: StudentId,
        }),
      ).unwrap();
      if (response.status == 200) {
        showSuccess('Submitted successfully');
        setFeesConfigurations(list);
      }
    } catch (err) {
      console.error(err);
      showError('Error in Submitting the fee details.');
    } finally {
      setIsSubmitting(false);
    }
  };
  const fetchFees = async () => {
    try {
      setLoading(true);
      const res = await dispatch(
        getOtherFeeTypesConfigurations(StudentId),
      ).unwrap();
      setFeesConfigurations(res.data);
      const total = res.data?.reduce((sum, f) => sum + Number(f.amount), 0);
      setTotalAmount(total);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (StudentId) fetchFees();
  }, [StudentId]);
  if (loading)
    return (
      <Card className='relative min-h-80 border'>
        <Spinner
          asOverlay={true}
          text={`Fetching the Total Fees Details of ${StudentId}`}
        />
      </Card>
    );
  if (!StudentId)
    return (
      <Card className='flex flex-col justify-center items-center h-60 border rounded-lg'>
        <PersonIcon className='text-gray-300 mb-1' style={{ fontSize: 90 }} />
        <Typography variant='h6' className='text-gray-400 mb-2'>
          No Student Selected
        </Typography>
        <Typography variant='body2' className='text-gray-500'>
          Please search for a student to know payment details.
        </Typography>
      </Card>
    );

  if (!feesConfigurations)
    return (
      <Card className='flex justify-center items-center h-60 border rounded-lg'>
        <Typography variant='body1'>Student details not found</Typography>
      </Card>
    );

  return (
    <Card className='max-w-4xl mx-auto p-6 border'>
      {/* Header */}
      <Box className='mb-4'>
        <Typography variant='h6' className='text-blue-700 font-bold'>
          Manage student related Fee Types
        </Typography>
        <Typography variant='body2' className='text-gray-600'>
          Configure all types of fees related to student
        </Typography>
      </Box>

      <div className=' w-full '>
        {/* Fee Types Configuration Table */}
        {/* Fee Types Configuration Table */}
        {feesConfigurations?.length == 0 ? (
          <Typography variant='body1' className='text-center'>
            No Additional Fees Configured to this student
          </Typography>
        ) : (
          <>
            <TableContainer
              component={Paper}
              variant='outlined'
              sx={{
                maxHeight: 400,
                overflow: 'auto',
              }}
            >
              <Table stickyHeader size='small' sx={{ minWidth: 700 }}>
                <TableHead>
                  <TableRow sx={{ backgroundColor: '#f8fafc' }}>
                    <TableCell className='text-blue-600'>
                      <strong>SNO</strong>
                    </TableCell>{' '}
                    <TableCell className='text-blue-600'>
                      <strong>Fee Type</strong>
                    </TableCell>{' '}
                    {/* <TableCell className='text-blue-600'>
                      <strong>Amount</strong>
                    </TableCell>{' '}
                    <TableCell className='text-blue-600'>
                      <strong>Paid</strong>
                    </TableCell>{' '}
                    <TableCell className='text-blue-600'>
                      <strong>Due Amount</strong>
                    </TableCell>{' '} */}
                    <TableCell className='text-blue-600'>
                      <strong>Enter Fee Amount</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {feesConfigurations?.map((feeType, index) => (
                    <TableRow
                      key={feeType?.id}
                      hover
                      sx={{
                        '&:nth-of-type(odd)': {
                          backgroundColor: '#fafafa',
                        },
                      }}
                    >
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{feeType.feeName}</TableCell>
                      {/* <TableCell>{`${formatNumber(feeType.amount)}/-`}</TableCell>
                      <TableCell>{`${formatNumber(feeType.amount - feeType.due)}/-`}</TableCell>
                      <TableCell>{`${formatNumber(feeType.due)}/-`}</TableCell> */}

                      <TableCell>
                        <TextField
                          style={{ width: 200 }}
                          size='small'
                          type='number'
                          min={0}
                          max='1000'
                          variant='standard'
                          value={feeType.amount}
                          onChange={(e) =>
                            handleAmountChange(index, e.target.value)
                          }
                          inputProps={{ min: 0, max: 200000 }}
                          error={feeType.due < 0}
                          helperText={
                            feeType.due < 0
                              ? `Amount cannot be less than paid Amount ${feeType.amount - feeType.due}`
                              : ''
                          }
                          disabled={feeType.feeName === 'Tuition Fee'}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            {/* Total */}
            <div className='flex justify-end mt-6 font-semibold text-lg'>
              Amount to Paid: ₹ {totalAmount}
            </div>
            {/* Submit */}
            <div className='mt-4 flex justify-end'>
              <Button
                disabled={
                  hasError ||
                  isSubmitting ||
                  totalAmount == 0 ||
                  status === 'DROPPED_OUT' ||
                  status === 'PASSED_OUT' ||
                  status === 'DELETED'
                }
                variant='contained'
                onClick={handleSubmit}
              >
                Submit
              </Button>
            </div>
          </>
        )}
      </div>
      <ToastNotification
        open={notification.open}
        onClose={hideNotification}
        message={notification.message}
        title={notification.title}
        severity={notification.severity}
        autoHideDuration={notification.autoHideDuration}
        position={notification.position}
      />
    </Card>
  );
}
